import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SYMBOLS = { USD: "$", GBP: "£", EUR: "€" };
const CurrencyContext = createContext(null);

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrencyState] = useState(
    () => localStorage.getItem("aigl_currency") || "USD"
  );
  const [detected, setDetected] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("aigl_currency");
    if (stored) {
      setDetected(true);
      return;
    }
    api
      .get("/geo/currency")
      .then((res) => {
        if (res.data?.currency) {
          setCurrencyState(res.data.currency);
          localStorage.setItem("aigl_currency", res.data.currency);
        }
      })
      .catch(() => {})
      .finally(() => setDetected(true));
  }, []);

  const setCurrency = (c) => {
    setCurrencyState(c);
    localStorage.setItem("aigl_currency", c);
  };

  return (
    <CurrencyContext.Provider
      value={{ currency, setCurrency, symbol: SYMBOLS[currency] || "$", detected }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
